import {Image, Segment} from "semantic-ui-react";

export default function DelageFooter(): JSX.Element {
    const logo = new URL("@/img/logo-coach-header.svg", import.meta.url).href;

    return (
        <Segment inverted attached className="footer">
            <Image
                src={logo}
                size="tiny"
                style={{marginLeft: "1.5em", height: 60}}
            />
        </Segment>
    );
}
